var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11765 3H7.99887C8.81668 3 9.5521 3.4979 9.85583 4.25722L10.9198 6.91708C11.2372 7.7107 10.9318 8.6174 10.1988 9.05718C9.42165 9.52348 9.12092 10.5174 9.6296 11.2675C10.4579 12.489 11.511 13.5421 12.7325 14.3704C13.4826 14.8791 14.4765 14.5784 14.9428 13.8012C15.3826 13.0682 16.2893 12.7628 17.0829 13.0802L19.7428 14.1442C20.5021 14.4479 21 15.1833 21 16.0011V18.8824C21 19.444 20.7769 19.9826 20.3798 20.3798C19.9826 20.7769 19.444 21 18.8824 21C14.7522 20.749 10.8566 18.9951 7.93076 16.0692C5.00489 13.1434 3.25099 9.24784 3 5.11765C3 4.55601 3.22311 4.01738 3.62024 3.62024C4.01738 3.22311 4.55601 3 5.11765 3Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9b803d94ca3cba361be9e287a2074fa1.svg";
export { ForwardRef as ReactComponent };